enum JobStatus {
  'Tentative',
  'Confirmed',
  'In Process',
  'Completed',
  'Closed'
}

export default JobStatus;
